import { Box, Flex, Text } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React from "react";
import { NavLink } from "react-router-dom";
import loginHero from "assets/img/login-hero.jpg";

function AuthIllustration(props) {
  const { children } = props;
  return (
    <Flex position="relative" h="max-content" bg="#F6F7F9">
      <Flex
        h={{
          sm: "initial",
          md: "unset",
          lg: "100vh",
          xl: "97vh",
        }}
        w="100%"
        maxW={{ md: "66%", lg: "1313px" }}
        mx="auto"
        pt={{ sm: "50px", md: "0px" }}
        px={{ lg: "30px", xl: "0px" }}
        ps={{ xl: "70px" }}
        justifyContent="start"
        direction="column"
      >
        <NavLink
          to="/admin/dashboard"
          style={() => ({
            width: "fit-content",
            marginTop: "40px",
          })}
        />
        {children}
        <Box
          display={{ base: "none", md: "block" }}
          h="100%"
          minH="100vh"
          w={{ lg: "50vw", "2xl": "44vw" }}
          position="absolute"
          right="0px"
          overflow="hidden"
          borderBottomLeftRadius={{ lg: "80px", xl: "120px" }}
        >
          <Box
            w="100%"
            h="100%"
            position="absolute"
            bgImage={`url(${loginHero})`}
            bgSize="cover"
            bgPosition="center"
          />
          <Box
            w="100%"
            h="100%"
            position="absolute"
            bg="linear-gradient(180deg, rgba(7, 50, 5, 0.18) 0%, rgba(7, 50, 5, 0.42) 55%, rgba(7, 50, 5, 0.78) 100%)"
          />
          <Flex
            position="absolute"
            inset="0"
            direction="column"
            justify="flex-end"
            align="flex-start"
            px={{ lg: "48px", xl: "64px" }}
            pb={{ lg: "56px", xl: "72px" }}
          >
            <Text
              color="white"
              fontSize={{ lg: "40px", xl: "50px" }}
              fontWeight="500"
              letterSpacing="0.4px"
              lineHeight="1.05"
              maxW="440px"
            >
              Natural Remedies You Can Trust.
            </Text>
            <Text
              color="rgba(255,255,255,0.82)"
              fontSize="18px"
              fontWeight="300"
              mt="16px"
              maxW="400px"
              lineHeight="1.4"
            >
              Your pocket guide to trustworthy, traditional remedies for everyday health.
            </Text>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
}

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
